import React from 'react';
import PropTypes from 'prop-types';

import ConfirmModal from "../Global/Modals/ConfirmModal";
import ModalContainer from '../Global/Modals/ModalContainer';

const MoveAndReplaceFolderModal = ({ modalIsOpen, onCloseClick, onReplaceClick, folderConflict, loading }) => (
  <ModalContainer
    isOpen={modalIsOpen}
    closeModal={onCloseClick}
    label="Move and replace modal"
  >
    <ConfirmModal
      title={`Replace folder?`}
      confirmText="Replace"
      onConfirmClick={onReplaceClick}
      onCloseClick={onCloseClick}
      loading={loading}
    >
      <p>
        {`A folder named "${folderConflict.title}" already exists in this location. `}
        {`Do you want to replace it with the one you're moving? `}
        {`This cannot be undone.`}
      </p>
    </ConfirmModal>
  </ModalContainer>
);

MoveAndReplaceFolderModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onReplaceClick: PropTypes.func.isRequired,
  folderConflict: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default MoveAndReplaceFolderModal;



// WEBPACK FOOTER //
// ./library/app/components/Folders/MoveAndReplaceFolderModal.js